export default {
    brief: 0,
    business: 4,
    join: 5,
    news: 6,
    questions: 0,
    feedback: 1
};
